
import { defineComponent } from "vue"

const SCRIPT_ID = "captcha-script"

export default defineComponent({
  mounted () {
    const script = document.createElement("script")
    script.src = "https://smartcaptcha.yandexcloud.net/captcha.js"
    script.id = SCRIPT_ID
    script.async = true
    script.defer = true

    script.onload = () => {
      const el = this.$refs.container as HTMLDivElement
      if (el) window.smartCaptcha?.render(el, {
        sitekey: this.$config.smartcaptchaSitekey,
        callback: (token: string) => window.captchaCb?.(token),
        hl: "ru",
        invisible: true,
        hideShield: true,
        // test: true,
      })
    }

    document.head.appendChild(script)
  },

  beforeDestroy () {
    window.smartCaptcha?.destroy()
    document.getElementById(SCRIPT_ID)?.remove()
    delete window.captchaCb
  },
})
